import { render, staticRenderFns } from "./SendToRoute.vue?vue&type=template&id=2023da44&scoped=true"
import script from "./SendToRoute.vue?vue&type=script&lang=js"
export * from "./SendToRoute.vue?vue&type=script&lang=js"
import style0 from "./SendToRoute.vue?vue&type=style&index=0&id=2023da44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2023da44",
  null
  
)

export default component.exports